import { Spinner2, Text } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: ${(props) => (props.col ? props.col : theme.SECONDARY)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  cursor: pointer;
  margin: ${(props) => (props.marg ? props.marg : '0')};
  padding: ${(props) => (props.pad ? props.pad : '5px')};

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 1;
    transform: scale(0.98);
  }

  transition: opacity 0.3s;
`;

const SportsSelect = styled(StyledButton)`
  height: ${(props) => (props.isMobile ? '30px' : ' 54px')};
  width: ${(props) => (props.isMobile ? '124px' : ' 220px')};
  ${(props) => props.wid && `width: ${props.wid};`}
`;

const SmallButton = styled(StyledButton)`
  height: 54px;
  width: 178px;
`;

const RegularButton = styled(StyledButton)`
  height: ${(props) => (props.isMobile ? '39px' : '54px')};
  width: ${(props) =>
    props.contain ? '100% !important' : props.isMobile ? '286px !important' : '480px !important'};
  ${(props) => props.wid && `width: ${props.wid} !important;`}
  ${(props) => props.ht && `height: ${props.ht};`}

  p {
    text-align: center;
  }
`;

const Button = (props) => {
  const { isMobile } = global;

  function getStyle() {
    switch (true) {
      case props.sportsSelect:
        return (
          <SportsSelect isMobile={isMobile} {...props} disabled={props.isLoading || props.disabled}>
            <Text col={theme.PRIMARY_WHITE} size={props.isMobile || isMobile ? '16px' : '24px'}>
              {props.text}
            </Text>
          </SportsSelect>
        );

      case props.small:
        return (
          <SmallButton {...props} disabled={props.isLoading || props.disabled}>
            {(props.isLoading || props.disabled) && <Spinner2 />}

            {!props.isLoading && !props.disabled && (
              <Text col={theme.PRIMARY_WHITE}>{props.text}</Text>
            )}
          </SmallButton>
        );

      default:
        return (
          <RegularButton
            isMobile={isMobile}
            {...props}
            disabled={props.isLoading || props.disabled}
          >
            {(props.isLoading || props.disabled) && <Spinner2 />}

            {!props.isLoading && !props.disabled && (
              <Text
                col={theme.PRIMARY_WHITE}
                wid="80%"
                size={props.isMobile || isMobile ? '18px' : '24px'}
                {...props.textStyle}
              >
                {props.text}
              </Text>
            )}
          </RegularButton>
        );
    }
  }

  return getStyle();
};

export default Button;
